import { Button, styled } from '@mui/material';

const StyledButton = styled(Button)`
  border-radius: 1.5rem;
  font-size: 0.8rem;
  padding: 0.5rem 0.3rem;
`;
export default StyledButton;
